<header class="modal-header">
  <h1 class="h3 modal-title">{{ title }}</h1>
  <button
    type="button"
    [disabled]="isDismissDisabled"
    class="text-secondary-500 hover:opacity-75"
    aria-label="Zamknij okno"
    i18n-aria-label
    ndt-icon-button
    (click)="onDismiss()"
  >
    <app-icon name="close" size="lg"></app-icon>
  </button>
</header>

<div class="modal-body">
  <ng-content></ng-content>
</div>

<footer *ngIf="isFooterVisible" class="modal-footer">
  <ng-template #readonly>
    <button type="button" ndt-primary-button (click)="onDismiss()" i18n>Zamknij</button>
  </ng-template>
  <ng-container *ngIf="!isReadonly; else readonly">
    <button type="button" [disabled]="isDismissDisabled" ndt-tertiary-button (click)="onDismiss()">
      {{ dismissBtnLabel }}
    </button>
    <button type="button" [disabled]="isCloseDisabled" ndt-primary-button (click)="onClose()">
      {{ closeBtnLabel }}
    </button>
  </ng-container>
</footer>
